<template>
  <div class="rightModal">
    <Input
      label="servers.networkName"
      placeholder="servers.enterNetworkName"
      id="networkName"
      v-model="form.name"
      :state="validateState('name')"
    />

    <Input
      label="global.ipAddress"
      placeholder="examples.ip"
      id="ipAddress"
      v-model="form.ip"
      :state="validateState('ip')"
    />

    <Input
      label="global.subnet"
      placeholder="global.subnet"
      id="subnet"
      v-model="form.subnet"
      :state="validateState('subnet')"
    />

    <b-form-group :label="$t('global.type')" :state="validateState('type')">
      <multiselect
        v-model="form.type"
        :options="typeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('global.type')"
        :show-no-results="false"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AddNetworkDevice',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        name: '',
        ip: '',
        subnet: '',
        type: '',
      },
      typeList: [
        { id: 'public', name: 'Public' },
        { id: 'private', name: 'Private' },
        { id: 'vpn', name: 'VPN' },
        { id: 'core', name: 'CORE' },
        { id: 'management', name: 'Management' },
        { id: 'storage', name: 'Storage' },
      ],
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      ip: {
        required,
      },
      subnet: {
        required,
      },
      type: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        ip_addr: this.form.ip,
        subnet: Number(this.form.subnet),
        network_type: this.form.type.id,
        datacenter_node_id: this.$route.params.id,
      }
      ApiService.post('iaas/networks', params)
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
